import type { HyloServices } from '@/model';
import Dexie, { type Table } from 'dexie';
export interface RecoveryIntent {
    key: string;
    accountId: string;
    realmId: string;
    sourceId: string;
    destination_conversation_id: string;
    client_id: string;
    created_at: string;
}
class ChatinfoJournal extends Dexie {
    recoveries!: Table<RecoveryIntent, string>;
    constructor() { super('hylo.web.chatinfo'); this.version(1).stores({ recoveries: 'key,accountId,[realmId+accountId]' }); }
}
let database: ChatinfoJournal | undefined;
function journal() { return database ??= new ChatinfoJournal(); }
export function recoveryKey(identity: readonly unknown[], id: string) { return JSON.stringify([...identity, id]); }
export async function readRecovery(key: string) { return journal().recoveries.get(key); }
export async function retainRecovery(intent: RecoveryIntent, current: () => boolean) { return journal().transaction('rw', journal().recoveries, async () => { if (!current())
    throw new DOMException('Retired login', 'AbortError'); const existing = await journal().recoveries.get(intent.key); if (existing)
    return existing; await journal().recoveries.put(intent); if (!current())
    throw new DOMException('Retired login', 'AbortError'); return intent; }); }
export async function finishRecovery(key: string) { await journal().recoveries.delete(key); }
/** Called only for intentional local-data removal; normal sign-out keeps receipts. */
export async function removeAccountIntents(accountId: string) { await journal().recoveries.where('accountId').equals(accountId).delete(); }

const installed = new WeakSet<HyloServices>();
/** The service owns this subscription beyond a route's lifetime. */
export function installJournalCleanup(services: HyloServices) {
 if(installed.has(services))return;installed.add(services);
 services.session.onRetire(event => event.reason==='remove'||event.reason==='deleted' ? removeAccountIntents(event.accountId) : undefined);
}
